module.exports = __webpack_public_path__ + "img/thermometer.e2813296.png";